<template>
    <v-sheet>
        <v-card-subtitle class="px-6"> 상품을 선택하세요 </v-card-subtitle>
        <v-divider />
        <table-receivers v-model="orders" readonly showsProducts v-bind="{ form, isBulkOrder }" />
        <v-divider />
        <v-card-actions>
            <v-btn x-large text block color="primary" v-bind="{ disabled }" @click="emit">입력완료</v-btn>
        </v-card-actions>
    </v-sheet>
</template>

<script>
import TableReceivers from "./table-receivers.vue";

export default {
    components: {
        TableReceivers,
    },
    props: {
        form: { type: Object, default: () => ({}) }, // form
        value: { type: Array, default: () => [] }, // orders
        isBulkOrder: { type: Boolean, default: false },
    },
    data: () => ({
        orders: [],
    }),
    computed: {
        disabled() {
            return !this.orders.length || this.orders.some(({ products = [] }) => !products.some(({ quantity }) => +quantity));
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.orders = JSON.parse(JSON.stringify(this.value));
        },
        emit() {
            this.$emit("input", this.orders);
            this.$emit("forward");
        },
    },
};
</script>

<style>
</style>